import { Box, Typography } from '@mui/material';
import { Formik, useFormikContext } from 'formik';

import { LoadingButton, PaddingBox } from '~components/atoms/custom';
import { TextField } from '~components/atoms/form';
import {
  forgotPasswordValidationSchema,
  useForgotPasswordContext,
} from '~providers';

export type ForgotPasswordValues = {
  email: string;
  submit: unknown;
};

export const ForgotPasswordPage: React.FC = () => {
  const { forgotPasswordValues, handleSubmit } = useForgotPasswordContext();

  return (
    <Formik
      initialValues={forgotPasswordValues}
      onSubmit={handleSubmit}
      enableReinitialize
      validationSchema={forgotPasswordValidationSchema}
    >
      <ForgotPasswordPageView />
    </Formik>
  );
};

export const ForgotPasswordPageView = () => {
  const { isRequesting } = useForgotPasswordContext();

  const { submitForm, dirty } = useFormikContext<ForgotPasswordValues>();

  return (
    <PaddingBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={3}
      width="100%"
    >
      {/* Form Input */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={1}
        width="100%"
      >
        <Typography variant="h6" fontWeight={600}>
          Reset your password
        </Typography>
        <Typography color="text.placeholder" textAlign="center">
          Enter your email and we'll send you instructions to reset your
          password.
        </Typography>
      </Box>

      <TextField
        label={
          <Typography variant="body2" fontWeight={400}>
            Email
          </Typography>
        }
        name="email"
        type="email"
      />

      {/* Send Button */}
      <LoadingButton
        onClick={submitForm}
        disabled={!dirty}
        isLoading={isRequesting}
      >
        <Typography variant="body2" fontWeight={500}>
          Send
        </Typography>
      </LoadingButton>
    </PaddingBox>
  );
};
